<template>
  <div
    class="navigation-wrapper">
    <div class="navigation">
      <div class="logo-wrapper">
        <router-link
          :to="{name: 'Index'}"
          class="logo">
          爱车的诺诺
        </router-link>
      </div>

      <ul class="navi-anchors-wrapper">
        <li class="navi-anchor-wrapper">
          <router-link
            :to="{
              name: 'Index',
            }"
            :class="[
              'navi-anchor',
              isStandard ? 'active' : '',
            ]">
            精品自营车
          </router-link>
        </li>

        <li class="navi-anchor-wrapper">
          <router-link
            :to="{
              name: 'StandardDiscount',
              query: {
                category: 'discount'
              }
            }"
            :class="[
              'navi-anchor',
              isStandardDiscount ? 'active' : '',
            ]">
            特价区
          </router-link>
        </li>

        <li class="navi-anchor-wrapper">
          <router-link
            :to="{name: 'NuonMomentIndex'}"
            :class="[
              'navi-anchor',
              isNuonMoment ? 'active' : ''
            ]">
            诺圈
          </router-link>
        </li>

        <li class="navi-anchor-wrapper">
          <router-link
            :to="{name: 'Recycle'}"
            :class="[
              'navi-anchor',
              $route.path === '/recycle' ? 'active' : ''
            ]">
            卖车
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import {computed} from 'vue'
import {useRoute} from 'vue-router'

defineOptions({
  name: 'SiteNavigation',
})

const route = useRoute()

// isStandard
// - 2023.06.12
// - Check if the current route is standard related
const isStandard = computed(() => {
  if (route.name === 'Index') {
    return true
  }

  if (route.path.startsWith('/car') && route.query.category === 'premium') {
    return true
  }

  return false
})

// isStandardDiscount
// - 2025.01.10
// - Determine whether the discount route is currently active
const isStandardDiscount = computed(() => {
  if (route.name === 'StandardDiscount') {
    return true
  }

  if (route.path.startsWith('/car') && route.query.category === 'discount') {
    return true
  }

  return false
})

// isNuonMoment
// - 2025.05.13
// - Check if the current route is nuon moment related
const isNuonMoment = computed(() => {
  return route.matched.some(record => record.name === 'NuonMoment')
})

</script>

<style lang="scss" scoped>
.navigation-wrapper {
  z-index: 100;
  position: fixed;
  width: 100%;
  height: 44px;
  background: var(--background);
  // position: relative;

  &::after {
    content: '';
    display: block;
    position: absolute;
    bottom: 0px;
    left: 0;
    right: 0px;
    height: 2px;
    background: var(--border-primary);
    transform: scaleY(.5);
  }
}

.navigation {
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
}

.logo-wrapper {
  display: none;
  padding: 0 10px;
  box-sizing: border-box;
  height: 100%;
}

.logo {
  background: transparent url('https://static.nuonuo.com.cn/zycmp/logo.png') center center no-repeat;
  text-indent: -9999px;
  background-size: 120%;
  white-space: nowrap;
  display: inline-block;
  width: 90px;
  height: 100%;
}

.navi-anchor-wrapper > li {
  flex: 1;
}

.navi-anchors-wrapper {
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  height: 100%;
  margin-left: unset;

  & > li {
    flex: 1;
    display: flex;
    justify-content: center;
  }

  & > li > a {
    margin: auto;
  }
}

.navi-anchor-wrapper {
  height: 100%;
  padding: 6px 0;
  box-sizing: border-box;
  display: flex;
  justify-content: stretch;
}

.navi-anchor {
  padding: 0 10px;
  height: 100%;
  box-sizing: border-box;
  display: inline-block;
}

.navi-anchor {
  display: flex;
  align-items: center;
  color: var(--black-secondary);
  font-size: .95rem;

  &:link,
  &:visited,
  &:hover {
    text-decoration: none;
  }

  &:hover {
    filter: brightness(.9);
  }
}

.navi-anchor.active {
  color: var(--black-primary);
  font-weight: bold;
  border-bottom: 2px solid var(--zcar-primary);
}

@media (min-width: 640px) {
  .logo-wrapper {
    display: block;
  }

  .logo {
    background: transparent url('https://static.nuonuo.com.cn/zycmp/logo.png') center center no-repeat;
    text-indent: -9999px;
    background-size: 90% auto;
    white-space: nowrap;
    display: inline-block;
    width: 180px;
    height: 100%;
  }

  .navigation-wrapper {
    height: 56px;

    .navigation {
      max-width: 1280px;
      margin: 0 auto;
    }
   }

  .navi-anchor {
    padding: 0 20px;
    font-size: 1rem;
    white-space: nowrap;
  }

  .navi-anchors-wrapper {
    margin-left: auto;
    width: auto;
  }
 }

@media (prefers-color-scheme: dark) {
  .logo {
    background: transparent url('https://static.nuonuo.com.cn/zycmp/logo-white-20241206.png') center center no-repeat;
    background-size: 90% auto;
  }
}

</style>
